import React from 'react';
import { formatCreatedAt } from '@/utils/format';

export function DisplayCreatedAt({
  createdAt,
  format = 'YYYY-MM-DD HH:mm:ss',
  isUnix = false,
}: {
  createdAt: number;
  format?: string;
  isUnix?: boolean;
}) {
  if (!createdAt) {
    return <div>-</div>;
  }
  return <div>{formatCreatedAt(createdAt, isUnix, format)}</div>;
}
